import helper from '@/libs/forms';


export default {
  fields: [
    helper.simpleInput('number', 'Number of Shares', null, 'shares', true),
    helper.simpleInput('text', 'Securities', null, 'securities', true),
    helper.currency('Cost', 'cost', true),
    helper.currency('Market Value Quotation / Exchange', 'marketValue', true),
    helper.date('Date of Quotation/Exchange', null, 'date', true, 12, null, false, true),
    helper.currency('Total Value', 'amount', true),
  ],
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/assets/schemas/stockAndBonds.js